<template>
	<div class="display-flex flex-column">
		<div v-for="(item, index) in menuItems" :key="index + item.iconName">
			<div class="menu-item-container display-flex flex-row flex-align-center mb-2">
				<AnemicButton @click="item.onClick && item.onClick()" class="radio-button-container flex-centerize mr-3">
					<SIcon
						:width="14"
						style="margin-left: -2px; margin-top: 1px"
						:name="`${selectedItemKey === item.key ? 'selected' : 'empty'}-radio-button`"
					/>
				</AnemicButton>
				<SIcon class="mr-2" :name="item.iconName" />
				{{ item.title }}
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { widgetMetadata } from '@/store/modules/widgetEditor/getters';
import { setWidgetOption } from '@/store/modules/widgetEditor/actions';
export default {
	name: 'WidgetLayoutSettingsPanel',
	components: {},
	computed: {
		...mapGetters([widgetMetadata.fullPath]),
		widgetOptions() {
			return this[widgetMetadata.fullPath].options;
		},
		hasPdf() {
			return this.widgetOptions.file_viewer?.active;
		},
	},
	methods: {
		...mapActions([setWidgetOption.fullPath]),
		onNarrowPdfLayout() {
			if (this.widgetOptions?.file_viewer?.active) {
				return this.closePdfLayout();
			}
			const newPdfValue = { ...this.widgetOptions.file_viewer, active: true };
			this.onShowNarrowLayout();
			this[setWidgetOption.fullPath]({ key: 'file_viewer', value: newPdfValue });
		},
		onShowWideLayout() {
			const newIsWideValue = { value: {}, active: true };
			this[setWidgetOption.fullPath]({ key: 'is_wide', value: newIsWideValue });
			this.closePdfLayout();
		},
		onShowNarrowLayout() {
			const newIsWideValue = { value: {}, active: false };
			this[setWidgetOption.fullPath]({ key: 'is_wide', value: newIsWideValue });
			this.closePdfLayout();
		},
		closePdfLayout() {
			const newPdfValue = { ...this.widgetOptions.file_viewer, active: false };
			this[setWidgetOption.fullPath]({ key: 'file_viewer', value: newPdfValue });
		},
		isWideLayout() {
			return this.widgetOptions?.is_wide?.active;
		},
		updateSelctedItemKey() {
			if (this.hasPdf) {
				this.selectedItemKey = 'narrow_pdf';
			} else if (this.isWideLayout()) {
				this.selectedItemKey = 'wide';
			} else {
				this.selectedItemKey = 'narrow';
			}
		},
	},
	data() {
		return {
			selectedItemKey: 'narrow',
			menuItems: [
				{
					key: 'narrow',
					title: 'Narrow interface',
					iconName: 'narrow-widget-layout',
					onClick: this.onShowNarrowLayout,
				},
				{
					key: 'wide',
					title: 'Wide interface',
					onClick: this.onShowWideLayout,
					iconName: 'wide-widget-layout',
				},
				{
					isSelected: true,
					key: 'narrow_pdf',
					onClick: this.onNarrowPdfLayout,
					title: 'Interface + document viewer',
					iconName: 'narrow-pdf-widget-layout',
				},
			],
		};
	},
	created() {
		this.updateSelctedItemKey();
	},
	watch: {
		widgetOptions: {
			handler() {
				this.updateSelctedItemKey();
			},
		},
	},
};
</script>

<style scoped lang="scss">
.menu-item-container {
	font-size: 14px;
	font-weight: normal;
	color: var(--primary-font-color);

	.radio-button-container {
		width: 20px !important;
		height: 20px !important;
		background: transparent;
		padding: 0px !important;
		border-radius: 10px !important;
	}
}
</style>
